module.exports = __webpack_public_path__ + "img/otf.66858151.svg";